import { gql } from '@apollo/client';

import type * as GraphQLTypes from '../../../graphql/types.generated';
export type CreateProductAttributeMutationVariables = GraphQLTypes.Exact<{
  input: GraphQLTypes.CreateCoreProductAttributeInput;
}>;

export type CreateProductAttributeMutationResult = { __typename?: 'Mutation' } & {
  createCoreProductAttribute: { __typename?: 'CreateCoreProductAttributePayload' } & {
    coreProductAttribute?: GraphQLTypes.Maybe<
      { __typename?: 'CoreProductAttribute' } & Pick<GraphQLTypes.CoreProductAttribute, 'id' | 'name' | 'type'>
    >;
    errors?: GraphQLTypes.Maybe<Array<{ __typename?: 'Error' } & Pick<GraphQLTypes.Error, 'message' | 'path'>>>;
  };
};

export const CreateProductAttributeDocument = gql`
  mutation createProductAttribute($input: CreateCoreProductAttributeInput!) {
    createCoreProductAttribute(input: $input) {
      coreProductAttribute {
        id
        name
        type
      }
      errors {
        message
        path
      }
    }
  }
`;
